import { Link, type LinkProps } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { localizedRoutes, type RouteKey } from '@/i18n/routes'
import type { SupportedLanguage } from '@/i18n'

interface LocalizedLinkProps extends Omit<LinkProps, 'to'> {
  to: RouteKey | string
}

export function LocalizedLink({ to, children, ...props }: LocalizedLinkProps) {
  const { i18n } = useTranslation()
  const currentLang = i18n.language as SupportedLanguage

  let path: string

  if (to in localizedRoutes) {
    const slug = localizedRoutes[to as RouteKey]
    path = slug ? `/${currentLang}/${slug}` : `/${currentLang}`
  } else if (to.startsWith('/')) {
    path = `/${currentLang}${to}`
  } else if (to.startsWith('http') || to.startsWith('mailto:') || to.startsWith('tel:')) {
    path = to
  } else {
    path = `/${currentLang}/${to}`
  }

  return (
    <Link to={path} {...props}>
      {children}
    </Link>
  )
}
